export default function adresses(
  state = {
    modalAdresses: false,
    modalCreateAddress: false,
    adresses: [],
    currentLocation: null,
    createdAddress: null,
    createAddress: false,
    markerCoordinates: null,
    createAddressBasedOnMap: false,
    createdAddressBasedOnMap: null,
    searchAddress: false,
    neighborhoods: [],
  },
  action
) {
  switch (action.type) {
    case '@adresses/LOAD': {
      return {
        ...state,
        ...action.data,
      };
    }

    case '@adresses/MODAL': {
      return {
        ...state,
        modalAdresses: !state.modalAdresses,
      };
    }

    case '@adresses/CREATE': {
      return {
        ...state,
        modalCreateAddress: true,
      };
    }

    case '@adresses/CONFIRM_ADDRESS': {
      return {
        ...state,
        createAddress: true,
      };
    }

    case '@adresses/CONFIRM_ADDRESS_CREATED': {
      return {
        ...state,
        createdAddress: action.addressBasedOnLocation,
      };
    }

    case '@adresses/CONFIRM_ADDRESS_CREATE': {
      return {
        ...state,
        createAddressBasedOnMap: true,
      };
    }

    case '@adresses/CANCEL_ADDRESS_CREATE': {
      return {
        ...state,
        createAddressBasedOnMap: false,
      };
    }

    case '@adresses/ADDRESS_CREATED_MAP': {
      return {
        ...state,
        createdAddressBasedOnMap: action.createdAddressBasedOnMap,
      };
    }

    case '@adresses/SET_MARKER_COORD': {
      return {
        ...state,
        markerCoordinates: action.markerCoordinates,
      };
    }

    case '@adresses/CURRENT_LOCATION': {
      return {
        ...state,
        currentLocation: action.currentLocation,
      };
    }

    case '@adresses/CANCEL_ADDRESS': {
      return {
        ...state,
        createAddress: false,
      };
    }

    case '@adresses/CREATE_CANCEL': {
      return {
        ...state,
        modalCreateAddress: false,
      };
    }

    case '@adresses/CREATE_SUCCESS': {
      return {
        ...state,
        adresses: [...state.adresses, action.address],
        modalCreateAddress: false,
        createAddressBasedOnMap: false,
        searchAddress: false,
        createAddress: false,
      };
    }

    case '@adresses/SEARCH_ADDRESS': {
      return {
        ...state,
        searchAddress: !state.searchAddress,
      };
    }

    default:
      return state;
  }
}
